import type { AnalyStereo, AnalyView } from './analyContract';

/**
 * takeMedia — 서버 상세 응답에서 **다시 들을 수 있는 녹음 목록**을 뽑는 판정(순수).
 *
 * 재생은 서버에 올라간 원음만 다룬다(ADR-0007): 업로드가 안 된 테이크는 하위에 `media$`가
 * 없고, 그 행만 빠진다. 소유자가 아닌 호출(공유 링크 수신)에는 서버가 `media$`·`mediaId` 를
 * 아예 싣지 않는다(muzly-io/muzly-backend-api#5). 메인 뷰에는 `media$`가 없으므로(서버가 하위에만 싣는다) 보지 않는다.
 * 순서는 응답 순서가 아니라 진단 순서로 못 박는다 — 화면이 서버의 배열 순서에 기대면 합성
 * 순서가 바뀌는 날 재생 목록이 뒤섞인다.
 */

export interface TakeMedia {
  stereo: AnalyStereo;
  url: string;
}

const TAKE_ORDER: readonly AnalyStereo[] = ['sustain', 'low', 'high', 'song'];

export const takeMediaOf = (view: AnalyView): TakeMedia[] =>
  TAKE_ORDER.flatMap((stereo) => {
    const url = view.$childs?.find((c) => c.stereo === stereo)?.media$?.url;
    return url ? [{ stereo, url }] : [];
  });
